<template>
    <div class="container-side" :class="{active : sideActive}">
        <div class="content-side">
            <div class="btn-side" v-for="(data,index) in setMenu()"
                 :key="`${index}sideBtn`"
                 @click="movePage(data.path)"
                 :class="{'active':$route.meta.side === data.meta.side}">
                <div class="text-btn-side">{{ data.meta.sideName }}</div>
            </div>
        </div>

    </div>
    <div class="blur" v-if="sideActive"></div>
</template>

<script>
import AuthMixins from "@/mixins/AuthMixins";
import EventBus from "@/utils/event-bus";

export default {
    name: "SideMenu",
    mixins: [AuthMixins],
    data() {
        return {
            sideActive: false,
            blurDom : null
        }
    },
    created() {
        EventBus.$on('showSide', this.showSide);
    },
    mounted() {
        this.blurDom = document.querySelector('.blur-bg');
        document.addEventListener('click', this.closeMenuEvent);
    },
    beforeUnmount() {
        EventBus.$off('showSide', this.showSide);
    },
    methods: {

        closeMenuEvent(e) {
            const menu = document.querySelector('.container-side');
            const header = document.querySelector('.container-header');
            const target = e.target;
            if (menu && header && (menu.contains(target) || header.contains(target))) return;
            this.sideActive = false;
        },
        showSide() {
            this.sideActive = !this.sideActive;
            this.blurDom.classList.add('active');
        },
        setMenu(){
            return this.$router.options.routes.filter(route => {
                    return route.meta.role && route.meta.role.includes(this.getAdminType()) && route.meta.sideMenu
            });
        },

        movePage(path){
            this.$router.push(path)
            this.sideActive = false;
        }
    },
    watch: {
        sideActive(newVal) {
            if (newVal) {
                this.blurDom.classList.add('active');
            } else {
                this.blurDom.classList.remove('active');
            }
        }
    }

}
</script>

<style scoped>

</style>
